import { createSlice } from "@reduxjs/toolkit";
import { createFundraiserAPI, unpublishFundraiserAPI, updateFundraiserAPI } from "../../../api/publicApi";
import { PersonalFundraiserEditFormikProps } from "../../../utils/types";
import { showErrorToast, showSuccessToast } from "../../../utils/toast";

const data = {
  isLoading: false,
  error: "",
  message: null,
  data: null,
};

const manageFundraiserSlice = createSlice({
  name: "manageFundraiser",
  initialState: data,
  reducers: {
    manageFundraiserSlice(state) {
      state.isLoading = true;
    },
    manageFundraiserSliceSuccess(state, action) {
      state.isLoading = false;
      state.data = action.payload;
      state.message = null;
    },
    unpublishFundraiserSliceSuccess(state) {
      state.isLoading = false;
      state.message = null;
    },
    manageFundraiserSliceFailure(state, action) {
      state.isLoading = false;
      state.message = action.payload;
    },
    manageFundraiserSliceReset(state) {
      state.isLoading = false;
      state.message = null;
      state.data = null;
      state.error = "";
    },
  },
});

export const editFundraiserHandler = (user_id: string,org_id:string,body:any) => async (dispatch: any) => {
  try {
    dispatch(manageFundraiserAction.manageFundraiserSlice());
    const response: any = await updateFundraiserAPI(user_id,org_id,body);
    dispatch(manageFundraiserAction.manageFundraiserSliceSuccess(response));
    showSuccessToast(response?.message)
  } catch (e: any) {
    dispatch(manageFundraiserAction.manageFundraiserSliceFailure(e?.response?.data?.message));
    dispatch(manageFundraiserAction.manageFundraiserSliceReset());
    showErrorToast(e?.response?.data?.error_message)
  }
};
export const createFundraiserHandler = (user_id: string,body:any) => async (dispatch: any) => {
  try {
    dispatch(manageFundraiserAction.manageFundraiserSlice());
    const response: any = await createFundraiserAPI(user_id,body);
    dispatch(manageFundraiserAction.manageFundraiserSliceSuccess(response));
    showSuccessToast(response?.message)
  } catch (e: any) {
    dispatch(manageFundraiserAction.manageFundraiserSliceFailure(e?.response?.data?.message));
    dispatch(manageFundraiserAction.manageFundraiserSliceReset());
    showErrorToast(e?.response?.data?.error_message)
  }
};
export const unpublishFundraiserHandler = (user_id: string,org_id:string) => async (dispatch: any) => {
  try {
    dispatch(manageFundraiserAction.manageFundraiserSlice());
    const response: any = await unpublishFundraiserAPI(user_id,org_id);
    dispatch(manageFundraiserAction.unpublishFundraiserSliceSuccess(response));
    dispatch(manageFundraiserAction.manageFundraiserSliceReset());
    showSuccessToast(response?.message)
  } catch (e: any) {
    dispatch(manageFundraiserAction.manageFundraiserSliceFailure(e?.response?.data?.message));
    dispatch(manageFundraiserAction.manageFundraiserSliceReset());
    showErrorToast(e?.response?.data?.error_message)
  }
};
export default manageFundraiserSlice.reducer;
export const manageFundraiserAction = manageFundraiserSlice.actions;
